import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {MedicalReportModel} from '../../../api/entity/medicalReport.model';
import {MedicalReportConverter} from '../../../api/entity/medicalReport.converter';
import {MedicalReportDataService} from './medicalReportData.service';

@Injectable()
export class MedicalReportDataServiceAdapter extends AbstractDataServiceDtoAdapter<MedicalReportModel, MedicalReportConverter> {
    constructor(dataService: MedicalReportDataService, converter: MedicalReportConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): MedicalReportModel {
        return new MedicalReportModel();
    }
}
